.unsavedChanges {
  width: 720px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-12);
  padding: var(--spacing-32);
  background-color: var(--sparky-brand-white);

  .closeButton {
    position: absolute;
    top: var(--spacing-04);
    right: var(--spacing-04);
  }

  .buttonsWrapper {
    display: flex;
    gap: var(--spacing-24);
    align-items: center;
    justify-content: center;
  }
}
